export const SEARCH_DEBOUNCE_TIMEOUT = 300;
export const LOADER_VIEW_TIMEOUT = {
    delay: 1_000,
    period: 500,
};
export const RETRY_VIEW_TIMEOUT = {
    delay: 300,
    period: 300,
};
